export function createFacilitationId(prefix?: string): string {
  const runtimeCrypto = globalThis.crypto as Crypto & { randomUUID?: () => string };
  let value: string;
  if (typeof runtimeCrypto?.randomUUID === 'function') {
    value = runtimeCrypto.randomUUID();
  } else {
    const bytes = new Uint8Array(16);
    if (typeof runtimeCrypto?.getRandomValues === 'function') {
      runtimeCrypto.getRandomValues(bytes);
    } else {
      for (let index = 0; index < bytes.length; index += 1) {
        bytes[index] = Math.floor(Math.random() * 256);
      }
    }
    bytes[6] = (bytes[6] & 0x0f) | 0x40;
    bytes[8] = (bytes[8] & 0x3f) | 0x80;
    const hex = [...bytes].map((byte) => byte.toString(16).padStart(2, '0')).join('');
    value = `${hex.slice(0, 8)}-${hex.slice(8, 12)}-${hex.slice(12, 16)}-${hex.slice(16, 20)}-${hex.slice(20)}`;
  }
  return prefix ? `${prefix}-${value}` : value;
}
